/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const APPLICATION_LOAD = "APPLICATION_LOAD";
export const APPLICATION_LOAD_SUCCESS = "APPLICATION_LOAD_SUCCESS";
export const APPLICATION_LOAD_FAIL = "APPLICATION_LOAD_FAIL";

export const APPLICATIONS_FILTER_VALUE_ADD = "APPLICATIONS_FILTER_VALUE_ADD";
export const APPLICATIONS_FILTER_VALUE_REMOVE = "APPLICATIONS_FILTER_VALUE_REMOVE";
export const APPLICATIONS_FILTER_PROVINCE_VALUE_REMOVE =
  "APPLICATIONS_FILTER_PROVINCE_VALUE_REMOVE";
export const APPLICATIONS_FILTER_COUNTRY_VALUE_REMOVE = "APPLICATIONS_FILTER_COUNTRY_VALUE_REMOVE";
export const APPLICATIONS_FILTER_VALUE_UPDATE = "APPLICATIONS_FILTER_VALUE_UPDATE";

export const APPLICATIONS_SEARCH = "APPLICATIONS_SEARCH";
export const APPLICATIONS_SEARCH_SUCCESS = "APPLICATIONS_SEARCH_SUCCESS";
export const APPLICATIONS_SEARCH_FAIL = "APPLICATIONS_SEARCH_FAIL";
export const APPLICATIONS_RESET = "APPLICATIONS_RESET";

export const DOWNLOAD_APPLICATIONS_TO_CSV = "DOWNLOAD_APPLICATIONS_TO_CSV";
export const DOWNLOAD_APPLICATIONS_TO_CSV_FAIL = "DOWNLOAD_APPLICATIONS_TO_CSV_FAIL";
export const DOWNLOAD_APPLICATIONS_TO_CSV_SUCCESS = "DOWNLOAD_APPLICATIONS_TO_CSV_SUCCESS";
export const DOWNLOAD_APPLICATIONS_TO_CSV_CLEAN = "DOWNLOAD_APPLICATIONS_TO_CSV_CLEAN";

export const UPDATE_APPLICATION_STATUS = "UPDATE_APPLICATION_STATUS";
export const UPDATE_APPLICATION_STATUS_SUCCESS = "UPDATE_APPLICATION_STATUS_SUCCESS";
export const UPDATE_APPLICATION_STATUS_FAIL = "UPDATE_APPLICATION_STATUS_FAIL";

export const UPDATE_SELECTED_APPLICATION = "UPDATE_SELECTED_APPLICATION";
export const UPDATE_SELECTED_APPLICATION_EMAIL = "UPDATE_SELECTED_APPLICATION_EMAIL";

export const GET_ASSIGN_APPLICATION = "GET_ASSIGN_APPLICATION";
export const GET_ASSIGN_APPLICATION_SUCCESS = "GET_ASSIGN_APPLICATION_SUCCESS";
export const GET_ASSIGN_APPLICATION_FAIL = "GET_ASSIGN_APPLICATION_FAIL";

export const GET_AVAILABLE_ASSIGN_APPLICATION = "GET_AVAILABLE_ASSIGN_APPLICATION";
export const GET_AVAILABLE_ASSIGN_APPLICATION_SUCCESS = "GET_AVAILABLE_ASSIGN_APPLICATION_SUCCESS";
export const GET_AVAILABLE_ASSIGN_APPLICATION_FAIL = "GET_AVAILABLE_ASSIGN_APPLICATION_FAIL";

export const ASSIGN_APPLICATION = "ASSIGN_APPLICATION";
export const ASSIGN_APPLICATION_SUCCESS = "ASSIGN_APPLICATION_SUCCESS";
export const ASSIGN_APPLICATION_FAIL = "ASSIGN_APPLICATION_FAIL";
export const ASSIGN_APPLICATION_RESET = "ASSIGN_APPLICATION_RESET";

export const BULK_ASSIGN_APPLICATION = "BULK_ASSIGN_APPLICATION";
export const BULK_ASSIGN_APPLICATION_SUCCESS = "BULK_ASSIGN_APPLICATION_SUCCESS";
export const BULK_ASSIGN_APPLICATION_FAIL = "BULK_ASSIGN_APPLICATION_FAIL";
export const BULK_ASSIGN_APPLICATION_RESET = "BULK_ASSIGN_APPLICATION_RESET";

export const FLAG_APPLICATION = "FLAG_APPLICATION";
export const FLAG_APPLICATION_SUCCESS = "FLAG_APPLICATION_SUCCESS";
export const FLAG_APPLICATION_FAIL = "FLAG_APPLICATION_FAIL";
export const FLAG_APPLICATION_RESET = "FLAG_APPLICATION_RESET";

export const SCORE_APPLICATION = "SCORE_APPLICATION";
export const SCORE_APPLICATION_SUCCESS = "SCORE_APPLICATION_SUCCESS";
export const SCORE_APPLICATION_FAIL = "SCORE_APPLICATION_FAIL";
export const SCORE_APPLICATION_RESET = "SCORE_APPLICATION_RESET";

export const UPDATE_APPLICATION_LISTING_CURRENT_PAGE = "UPDATE_APPLICATION_LISTING_CURRENT_PAGE";
export const UPDATE_APPLICATION_LISTING_PAGE_SIZE = "UPDATE_APPLICATION_LISTING_PAGE_SIZE";

export const APPLICATION_SEARCH_SORTING_UPDATE = "APPLICATION_SEARCH_SORTING_UPDATE";
